var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gvl-faq" },
    [
      _c("h2", { staticClass: "mb-3" }, [
        _vm._v(
          "FAQs zum Stipendienprogramm der Verwertungsgesellschaften in NEUSTART KULTUR"
        )
      ]),
      _c("div", { staticClass: "notice-box" }, [
        _vm._v(
          "Das Antragsportal wurde vorzeitig geschlossen, da die Mittel aufgrund der Anzahl an Anträgen bereits ausgeschöpft sind."
        )
      ]),
      _c("p", { staticClass: "mb-2" }, [
        _vm._v(
          "Das Stipendienprogramm der Verwertungsgesellschaften in NEUSTART KULTUR zielt darauf ab, freiberufliche oder auf Produktionsdauer beschäftigte ausübende Künstler* dabei zu unterstützen, ihre Arbeit trotz Einschränkungen durch die COVID-19-Pandemie fortsetzen zu können. Es soll sie befähigen, auf die mit der Pandemie einhergehende rasante Digitalisierung aller Arbeitsbereiche zu reagieren und sich dem veränderten Umfeld kreativen Schaffens anzupassen. Dadurch sollen neben der notwendigen Wiedergewinnung eines vielfältigen und zunehmenden digitalen Kulturangebots auch Beschäftigungs- und Zukunftsperspektiven für Kulturschaffende entstehen."
        )
      ]),
      _c("p", [
        _vm._v(
          "Das Stipendienprogramm umfasst Stipendien in Höhe von 5.000,00 EUR pro Person für eine Stipendiendauer von vier Monaten. Hierbei handelt es sich um Fördermittel des Bundes."
        )
      ]),
      _c("p", { staticClass: "small-text mt-6" }, [
        _vm._v(
          "* Aufgrund der besseren Lesbarkeit wird im Text das generische Maskulinum verwendet. Gemeint sind jedoch immer alle Geschlechter (m/w/d)."
        )
      ]),
      _c("h3", { staticClass: "mt-10" }, [_vm._v("Fragen zum Stipendium")]),
      _c(
        "v-expansion-panels",
        { staticClass: "mt-3", attrs: { accordion: "", tile: "" } },
        _vm._l(_vm.scholarshipQuestions, function(item, index) {
          return _c(
            "v-expansion-panel",
            { key: index },
            [
              _c("v-expansion-panel-header", [_vm._v(_vm._s(item.q))]),
              _c("v-expansion-panel-content", { attrs: { eager: "" } }, [
                _c("div", { domProps: { innerHTML: _vm._s(item.a) } })
              ])
            ],
            1
          )
        }),
        1
      ),
      _c("h3", { staticClass: "mt-10" }, [_vm._v("Fragen zur Antragstellung")]),
      _c(
        "v-expansion-panels",
        { staticClass: "mt-3", attrs: { accordion: "", tile: "" } },
        _vm._l(_vm.applicationQuestions, function(item, index) {
          return _c(
            "v-expansion-panel",
            { key: index },
            [
              _c("v-expansion-panel-header", [_vm._v(_vm._s(item.q))]),
              _c("v-expansion-panel-content", { attrs: { eager: "" } }, [
                _c("div", { domProps: { innerHTML: _vm._s(item.a) } })
              ])
            ],
            1
          )
        }),
        1
      ),
      _c("h3", { staticClass: "mt-10" }, [
        _vm._v("Fragen zum Förderverfahren")
      ]),
      _c(
        "v-expansion-panels",
        { staticClass: "mt-3", attrs: { accordion: "", tile: "" } },
        _vm._l(_vm.fundingQuestions, function(item, index) {
          return _c(
            "v-expansion-panel",
            { key: index },
            [
              _c("v-expansion-panel-header", [_vm._v(_vm._s(item.q))]),
              _c("v-expansion-panel-content", { attrs: { eager: "" } }, [
                _c("div", { domProps: { innerHTML: _vm._s(item.a) } })
              ])
            ],
            1
          )
        }),
        1
      ),
      _c("h3", { staticClass: "mt-10" }, [
        _vm._v("Fragen zur Abrechnung der Förderung")
      ]),
      _c(
        "v-expansion-panels",
        { staticClass: "mt-3", attrs: { accordion: "", tile: "" } },
        _vm._l(_vm.settlementQuestions, function(item, index) {
          return _c(
            "v-expansion-panel",
            { key: index },
            [
              _c("v-expansion-panel-header", [_vm._v(_vm._s(item.q))]),
              _c("v-expansion-panel-content", { attrs: { eager: "" } }, [
                _c("div", { domProps: { innerHTML: _vm._s(item.a) } })
              ])
            ],
            1
          )
        }),
        1
      ),
      _c("h3", { staticClass: "mt-10" }, [_vm._v("Sonstige Fragen")]),
      _c(
        "v-expansion-panels",
        { staticClass: "mt-3 mb-10", attrs: { accordion: "", tile: "" } },
        _vm._l(_vm.otherQuestions, function(item, index) {
          return _c(
            "v-expansion-panel",
            { key: index },
            [
              _c("v-expansion-panel-header", [_vm._v(_vm._s(item.q))]),
              _c("v-expansion-panel-content", { attrs: { eager: "" } }, [
                _c("div", { domProps: { innerHTML: _vm._s(item.a) } })
              ])
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }